export class CycleInfo {
  Id: number
  CycleCode: string
  CycleName: string
  FlagDelete: string
  CreateBy: string
  CreateByDisplay: string
  CreateDate: string
  UpdateBy: string
  UpdateByDisplay: string
  UpdateDate: string
}
